module.exports = {"id":"156412","name":"José de Jesús Corona","rating":"76","photo":"./data/images/photos/4/156412.png","club":{"name":"Cruz Azul","logo":"./data/images/clubs/CruzAzul.png"},"positions":["G"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JosedeJesusCorona0.json
// module id = 2183
// module chunks = 0